export interface Issue {
  id: string;
  title: string;
  category: string;
  severity: "low" | "medium" | "high" | "critical";
  printerType: string[];
  tags: string[];

  whatItLooksLike: string;

  symptoms?: string[];
  causes: string[];
  quickChecks?: string[];
  fixes: string[];
  prevention: string[];
  supplies: string[];

  difficulty?: "easy" | "intermediate" | "advanced";
  estimatedTime?: string;
  whenToCallTech?: string;
  notes?: string[];
  warning?: string;

  relatedIssues: string[];
}

export interface Card {
  id: string;
  problem: string;
  category?: string;
  severity?: "low" | "medium" | "high" | "critical";
  cause: string | string[];
  fix: string | string[];
}

export interface DecisionOption {
  label: string;
  next: string;
  image?: string;
  score?: Record<string, number>;
}

export interface DecisionNode {
  id: string;

  question?: string;
  helperText?: string;
  options?: DecisionOption[];

  type?: "result";
  title?: string;
  severity?: "low" | "medium" | "high" | "critical";
  confidence?: "low" | "medium" | "high";

  cause?: string;
  doFirst?: string[];
  fixes?: string[];
  alternatives?: string[];
  avoid?: string[];
  prevention?: string;
  supplies?: string[];
  related?: string[];
}

export interface MaintenanceItem {
  id: string;
  task: string;
  estimatedTime: string;
}

export interface MaintenanceChecklist {
  title: string;
  description: string;
  items: MaintenanceItem[];
}

export interface Note {
  id: string;
  issueId?: string;
  cardId?: string;
  title: string;
  content: string;
  createdAt: string;
  updatedAt: string;
}

export type SeverityLevel = "low" | "medium" | "high" | "critical";

export type IssueDifficulty = "easy" | "intermediate" | "advanced";

export const severityColors: Record<SeverityLevel, string> = {
  low: "bg-green-500/20 text-green-400 border-green-500/30",
  medium: "bg-yellow-500/20 text-yellow-400 border-yellow-500/30",
  high: "bg-orange-500/20 text-orange-400 border-orange-500/30",
  critical: "bg-red-500/20 text-red-400 border-red-500/30",
};

export const categoryLabels: Record<string, string> = {
  "print-quality": "Print Quality",
  "white-ink": "White Ink",
  adhesion: "Adhesion & Powder",
  hardware: "Hardware",
  film: "Film Issues",
  "heat-press": "Heat Press",
  environment: "Environment",
};